import { render, staticRenderFns } from "./DownloadTopUpPdfModalPati.vue?vue&type=template&id=448c6eae&scoped=true&"
import script from "./DownloadTopUpPdfModalPati.vue?vue&type=script&lang=js&"
export * from "./DownloadTopUpPdfModalPati.vue?vue&type=script&lang=js&"
import style0 from "./DownloadTopUpPdfModalPati.vue?vue&type=style&index=0&id=448c6eae&lang=scss&scoped=true&"
import style1 from "./DownloadTopUpPdfModalPati.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448c6eae",
  null
  
)

export default component.exports